import { cva } from "class-variance-authority"
import { Typography, typographyTypes } from "./Typography"
import cn from "../../../utils/classes"

export interface TagProps {
  text: string
  styleOverrides?: string
  typographyStyleOverrides?: string
}

const Tag: React.FC<TagProps> = ({
  text,
  styleOverrides,
  typographyStyleOverrides,
}) => {
  const rootVariants = cva([], {
    variants: {
      variant: {
        normal:
          "flex flex-wrap items-center rounded-full bg-gray-100 rounded w-max",
      },
    },
  })
  const tagClassName = cn(rootVariants({ variant: "normal" }), styleOverrides)

  return (
    <div className={tagClassName}>
      <Typography
        text={text}
        variant={typographyTypes.NORMAL}
        styleOverrides={`py-0.5 px-1.5 font-medium whitespace-nowrap ${typographyStyleOverrides}`}
      />
    </div>
  )
}

export default Tag
